import { SnackbarOrigin } from '@material-ui/core/Snackbar/Snackbar';
import clsx from 'clsx';
import React from 'react';

import { MuiAlert, MuiSnackbar, MuiButton, MuiAlertTitle } from '../material-ui';

import useStyles from './SnackbarAlert.styles';

export type AlertMessage = {
  title?: string;
  message?: string;
  actionLabel?: string;
  duration?: number | null;
  onAction?: () => void;
  onClose?: () => void;
  position?: SnackbarOrigin | undefined;
  overlay?: boolean;
  actionRequired?: boolean;
};

export interface SnackbarAlertProps {
  open: boolean;
  onClose: () => void;
  severity: 'error' | 'warning' | 'info' | 'success';
  alertMessage?: AlertMessage;
}

const SnackbarAlert = ({
  open,
  onClose,
  severity,
  alertMessage = { message: '', duration: 4000 },
}: SnackbarAlertProps) => {
  const classes = useStyles({});
  // Bottom gap needed for "livechat" widget space.
  const isBottomPositioned =
    alertMessage?.position?.vertical === 'bottom' || !alertMessage?.position?.vertical;

  return (
    <>
      {alertMessage.overlay && <div className={clsx(classes.overlay, open && 'is-visible')} />}
      <MuiSnackbar
        open={open}
        autoHideDuration={alertMessage.duration}
        onClose={() => {
          if (alertMessage.actionRequired) return;

          onClose();

          if (alertMessage.onClose) alertMessage.onClose();
        }}
        anchorOrigin={alertMessage?.position}
        className={clsx(isBottomPositioned && classes.bottomPositioned)}
      >
        <MuiAlert
          severity={severity}
          action={
            alertMessage.actionLabel ? (
              <MuiButton
                color="inherit"
                size="small"
                onClick={() => {
                  onClose();
                  if (alertMessage.onAction) alertMessage.onAction();
                }}
              >
                {alertMessage.actionLabel}
              </MuiButton>
            ) : null
          }
        >
          {alertMessage.title && <MuiAlertTitle>{alertMessage.title}</MuiAlertTitle>}
          {alertMessage.message}
        </MuiAlert>
      </MuiSnackbar>
    </>
  );
};

export default SnackbarAlert;
